import { Outlet } from 'react-router'
import { useThemeColor } from '../hooks/StatusBarColorPicker'
import { Header, HeaderSpacer } from './Header'
import { InstallPrompt } from './InstallPrompt'
import { TabBar } from './TabBar'

const TAB_BAR_OFFSET = 'calc(64px + env(safe-area-inset-bottom, 0px))'

export function AppShell() {
  useThemeColor('#454548') // match the gray-900 header

  return (
    <div className="min-h-dvh bg-gray-50">
      <Header />
      <main
        className="min-h-dvh"
        style={{ paddingBottom: TAB_BAR_OFFSET }}
      >
        <HeaderSpacer />
        <div className="mx-auto w-full max-w-screen-sm md:max-w-4xl">
          <InstallPrompt className="px-4 py-3" />
          <Outlet />
        </div>
      </main>
      <TabBar />
    </div>
  )
}
